import React from 'react';
import { Link } from "react-router-dom";

import './FenceButton.scss';

interface IFenceButtonProps {
    type: 'selectAll' | 'addFence';
    onClick?: () => void;
    linkTo?: string;
    label?: string;
    isSelected?: boolean;
    title?: string;
}

const FenceButton = ({ type, onClick, linkTo, label, isSelected, title }: IFenceButtonProps) => {
    return (
        <>
            {type === 'selectAll' && (
                <button className="FenceButton-White" onClick={onClick}>
                    {isSelected ? 'Clear All' : 'Select All'}
                </button>
            )}

            {type === 'addFence' && linkTo && (
                <Link
                  to={linkTo}
                  onClick={onClick}
                  title={title || 'Create New Fence'}
                >
                    <button className="FenceButton-Black">
                        {label || 'Add Fence'}
                    </button>
                </Link>
            )}
        </>
    );
};

export default FenceButton;
